module.exports = __webpack_public_path__ + "img/idea.d17ef8da.svg";